import { StoryblokSkinTypeTest } from './StoryblokSkinTypeTest'

export default StoryblokSkinTypeTest
